import { HugeiconsIcon } from "@hugeicons/react";
import {
    // General
    Home01Icon as Home01IconData,
    BookOpen01Icon as BookOpen01IconData,
    UserGroupIcon as UserGroupIconData,
    Analytics01Icon as Analytics01IconData,
    Settings02Icon as Settings02IconData,
    Notification02Icon as Notification02IconData,
    Logout02Icon as Logout02IconData,
    VideoReplayIcon as VideoReplayIconData,
    PlayCircleIcon as PlayCircleIconData,
    ArrowLeft02Icon as ArrowLeft02IconData,
    ArrowRight02Icon as ArrowRight02IconData,
    DashboardSpeed01Icon as DashboardSpeed01IconData,

    // Social / Contact
    Message01Icon as Message01IconData,
    Cancel01Icon as Cancel01IconData,
    Linkedin01Icon as Linkedin01IconData,
    InstagramIcon as InstagramIconData,
    CallIcon as Call01IconData,

    // Nav
    Search01Icon as Search01IconData,
    Menu01Icon as Menu01IconData,

    // Stats
    MoneyBag02Icon as MoneyBag02IconData,
    Calendar03Icon as Calendar03IconData

} from "@hugeicons/core-free-icons";

const IconWrapper = ({ icon, ...props }) => {
    return <HugeiconsIcon icon={icon} {...props} />;
}

export const Home01Icon = (props) => <IconWrapper icon={Home01IconData} {...props} />;
export const BookOpen01Icon = (props) => <IconWrapper icon={BookOpen01IconData} {...props} />;
export const UserGroupIcon = (props) => <IconWrapper icon={UserGroupIconData} {...props} />;
export const Analytics01Icon = (props) => <IconWrapper icon={Analytics01IconData} {...props} />;
export const Settings02Icon = (props) => <IconWrapper icon={Settings02IconData} {...props} />;
export const Notification02Icon = (props) => <IconWrapper icon={Notification02IconData} {...props} />;
export const Logout02Icon = (props) => <IconWrapper icon={Logout02IconData} {...props} />;
export const VideoReplayIcon = (props) => <IconWrapper icon={VideoReplayIconData} {...props} />;
export const PlayCircleIcon = (props) => <IconWrapper icon={PlayCircleIconData} {...props} />;
export const ArrowLeft02Icon = (props) => <IconWrapper icon={ArrowLeft02IconData} {...props} />;
export const ArrowRight02Icon = (props) => <IconWrapper icon={ArrowRight02IconData} {...props} />;
export const DashboardSpeed01Icon = (props) => <IconWrapper icon={DashboardSpeed01IconData} {...props} />;

export const Message01Icon = (props) => <IconWrapper icon={Message01IconData} {...props} />;
export const Cancel01Icon = (props) => <IconWrapper icon={Cancel01IconData} {...props} />;
export const Linkedin01Icon = (props) => <IconWrapper icon={Linkedin01IconData} {...props} />;
export const InstagramIcon = (props) => <IconWrapper icon={InstagramIconData} {...props} />;
export const Call01Icon = (props) => <IconWrapper icon={Call01IconData} {...props} />;

export const Search01Icon = (props) => <IconWrapper icon={Search01IconData} {...props} />;
export const Menu01Icon = (props) => <IconWrapper icon={Menu01IconData} {...props} />;

export const MoneyBag02Icon = (props) => <IconWrapper icon={MoneyBag02IconData} {...props} />;
export const Calendar03Icon = (props) => <IconWrapper icon={Calendar03IconData} {...props} />;
